import pick from 'lodash-es/pick';

enum IDVerificationStatus {
  NO_VERIFICATION_NEEDED = 'NO_VERIFICATION_NEEDED',
  VERIFICATION_FAILED_ALLOW_RETRY = 'VERIFICATION_FAILED_ALLOW_RETRY',
  VERIFICATION_FAILED_NO_RETRY = 'VERIFICATION_FAILED_NO_RETRY',
  VERIFICATION_NEEDED = 'VERIFICATION_NEEDED',
  VERIFICATION_PROCESSING = 'VERIFICATION_PROCESSING',
  VERIFICATION_SUBMITTED = 'VERIFICATION_SUBMITTED',
  VERIFICATION_SUCCEEDED = 'VERIFICATION_SUCCEEDED',
}

type JSONIDVerification = {
  errors: {
    code: Maybe<string>;
    reason: Maybe<string>;
  };
  state: IDVerificationStatus;
};

type IDVerification = {
  errors: string[];
  state: IDVerificationStatus;
};

const fromJSON = (idVerification: JSONIDVerification): IDVerification => ({
  errors: Object.values(pick(idVerification.errors, ['code'])).filter((v) => v) as string[],
  state: idVerification.state,
});

export { IDVerification, IDVerificationStatus, JSONIDVerification, fromJSON };
